var autoComputeFirstScreenTime = require('auto-compute-first-screen-time');
export function calculateT2Time() {
  return new Promise(function (resolve) {
    autoComputeFirstScreenTime({
      onReport: function onReport(result) {
        if (result.success) {
          resolve(result.firstScreenTime);
        } else {
          resolve(0);
        }
      }
    });
  });
}